import { ExtrudeGeometry, ExtrudeGeometryOptions, Shape } from '../../thirdparty/three/imports';
import { BufferGeometry3D } from '../core/BufferGeometry3D';

export class ExtrudeGeometry3D extends BufferGeometry3D
{
    shapes?: Shape | Shape[];
    options?: ExtrudeGeometryOptions;

    get _geometry()
    {
        if (!this.__geometry)
        {
            this.__geometry = new ExtrudeGeometry(this.shapes, this.options);
        }

        return this.__geometry;
    }
    declare protected __geometry: ExtrudeGeometry;

    constructor()
    {
        super();
    }
}
